module.exports = __webpack_public_path__ + "img/5ac_21.0c593bfd.gif";